import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { DirectivesModule } from '../../directives/directives.module';
import { PanelTextureSettingsComponent } from './panel-texture-settings.component';

@NgModule({
  declarations: [PanelTextureSettingsComponent],
  imports: [MatButtonToggleModule, MatIconModule, FuseSharedModule, DirectivesModule],
  exports: [PanelTextureSettingsComponent],
})
export class PanelTextureSettingsModule {}
